import { put, takeLatest } from "redux-saga/effects";
import { postCreateOrderApi } from "store/api/OrderApi";
import { POST_CREATE_ORDER_ACTION } from "../../actions/OrderPageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* postCreateOrder(action) {
	yield put(globalAction.openLoadingPage());
	const { dataCreate, business, onSuccess, onFail } = action.params;
	const res = yield postCreateOrderApi(dataCreate);
	try {
		if (res?.code === 0) {
			const data = res?.data[`${business}`];
			const dataResp = {
				orderId: data?.orderId,
				crmLevel: data?.crmLevel,
				remainingSales: data?.remainingSales
			};
			onSuccess(dataResp);
		} else {
			onFail(res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postCreateOrderSaga() {
	yield takeLatest(POST_CREATE_ORDER_ACTION, postCreateOrder);
}

export default postCreateOrderSaga;
